import { useEffect, useState } from 'react';

import getTemplateSchemas from '@/shared/api/shipping/profiles/getTemplateSchemas';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import ProfilesTemplateSchemas from '@/shared/types/shipping/profilesTemplateSchemas.type';

const useFetchTemplateSchemas = () => {
  const redirectLogin = useRedirectLogin();

  const [templateSchemas, setTemplateSchemas] =
    useState<ProfilesTemplateSchemas | null>(null);

  useEffect(() => {
    const fetchTemplateSchemas = async () => {
      const response = await getTemplateSchemas({
        providerKey: 'FC',
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        setTemplateSchemas(response.data);
      }
    };

    void fetchTemplateSchemas();
  }, [redirectLogin]);

  return { templateSchemas };
};

export default useFetchTemplateSchemas;
